import Vue from "vue";

const {$wApi} = Vue.prototype;

import {checkProtocolLink} from "@/mixins/makeLinkInfo";

const state = {
    $wApi,
    registDictionaryPopupOpenFlag: false,
    isSameDictionary: false,
    registTargetCategory: "",
    registProcess: {},
    registMaterial: {},
    registMeasurement: {},
    registAnalysis: {},
    registEquipment: {},
    resetLinkNodeFunc: null,
    tagAddBtnNewData: {},
    tagAddBtnNewFunc: null,
    tagAddBtnNewOpenFlag: false,
    dictionaryCheckKey: 0,
}; // end of state

const getters = {
    getRegistDictionaryPopupOpenFlag(state: any) {
        return state.registDictionaryPopupOpenFlag;
    },
    getRegistTargetCategory(state: any) {
        return state.registTargetCategory;
    },
    getRegistProcess(state: any) {
        return state.registProcess;
    },
    getRegistMaterial(state: any) {
        return state.registMaterial;
    },
    getRegistMeasurement(state: any) {
        return state.registMeasurement;
    },
    getRegistAnalysis(state: any) {
        return state.registAnalysis;
    },
    getRegistEquipment(state: any) {
        return state.registEquipment;
    },
    getIsSameDictionary(state: any) {
        return state.isSameDictionary;
    },
    getTagAddBtnNewData(state: any) {
        return state.tagAddBtnNewData;
    },
    getTagAddBtnNewFunc(state: any) {
        return state.tagAddBtnNewFunc;
    },
    getTagAddBtnNewOpenFlag(state: any) {
        return state.tagAddBtnNewOpenFlag;
    },
    getDictionaryCheckKey(state: any) {
        return state.dictionaryCheckKey;
    },
}; // end of getters 

const mutations = {
    setState(state: any, [key, value]) {
        state[key] = value;
    },
    setRegistDictionaryPopupOpenFlag(state: any, openFlag: boolean) {
        state.registDictionaryPopupOpenFlag = openFlag;
    },
    setRegistTargetCategory(state: any, category: string) {
        state.registTargetCategory = category;
    },
    setRegistProcess(state: any, dataObj: object) {
        state.registProcess = {...dataObj};
    },
    setRegistMaterial(state: any, dataObj: object) {
        state.registMaterial = {...dataObj};
    },
    setRegistMeasurement(state: any, dataObj: object) {
        state.registMeasurement = {...dataObj};
    },
    setRegistAnalysis(state: any, dataObj: object) {
        state.registAnalysis = {...dataObj};
    },
    setRegistEquipment(state: any, dataObj: object) {
        state.registEquipment = {...dataObj};
    },
    setIsSameDictionary(state: any, flag: boolean) {
        state.isSameDictionary = flag;
    },
    setResetLinkNodeFunc(state: any, func: any) {
        state.resetLinkNodeFunc = func;
    },
    setTagAddBtnNewData(state: any, dataObj: object) {
        state.tagAddBtnNewData = {...dataObj};
    },
    setTagAddBtnNewFunc(state: any, func: any) {
        state.tagAddBtnNewFunc = func;
    },
    setTagAddBtnNewOpenFlag(state: any, flag: boolean) {
        state.tagAddBtnNewOpenFlag = flag;
    },
    setDictionaryCheckKey(state: any, flag: boolean) {
        state.dictionaryCheckKey = flag;
    },
}; // end of mutations 

const actions = {
    /**
     * 구조에 맞게 데이터를 넘기면 tag를 사전에 신청할 수 있도록 데이터를 setting (correctionTargetKey이 표시어 수정 대상임)
     * @param targetData EX : {targetProcessId : 91, targetkey : "123-qwe-123-qwe", correctionTargetProcessId : 32, correctionTargetKey : "dfg-345-dfh-542"}
     */
    async setRegistDictionaryData({state, commit, dispatch}, {targetProcessId, targetkey, correctionTargetProcessId, correctionTargetKey}) {
        dispatch("resetRegistDictionaryData", {category: "ALL"});

        let {$wApi} = state;
        let targetProcess = await $wApi.process.detail(null, targetProcessId);
        if(targetProcess.processType == 'NORMAL'){ // 연결하려는 상대가 공정도인 경우 공개 데이터를 확인한다
            targetProcess = await $wApi.process.release.detail(null, targetProcessId);
            targetProcess["json"] = targetProcess["content"]; 
        }
        const correctionTargetProcess = await $wApi.process.detail(null, correctionTargetProcessId);

        const targetProcessLinks = JSON.parse(targetProcess.json)["links"];
        const targetProcessNodes = JSON.parse(targetProcess.json)["nodes"];

        const correctionTargetProcessLinks = JSON.parse(correctionTargetProcess.json)["links"];
        const correctionTargetProcessNodes = JSON.parse(correctionTargetProcess.json)["nodes"];

        const targetProcessData = checkProtocolLink(targetProcessLinks, targetProcessNodes, targetkey);
        const correctionTargetProcessData = checkProtocolLink(correctionTargetProcessLinks, correctionTargetProcessNodes, correctionTargetKey);

        const initObj = {
            registFlag: false,
            targetProcessNode: null,
            correctionTargetProcessNode: null,
            targetDataType: null,
            targetDataId: null,
            correctionTargetType: null, // 수정 대상의 data type
            correctionTargetId: null,   // 수정 대상의 data id
        };

        let processObj = {...initObj};
        let materialObj = {...initObj};
        let analysisObj = {...initObj};
        let measurementObj = {...initObj};
        let equipmentObj = {...initObj};

        for (let item of Object.entries(targetProcessData.nodeInfo)) {
            // nodeInfo에서 첫번쨰 데이터를 사용
            let targetProcessNode = item[1][Object.keys(item[1])[0]][0];
            switch (targetProcessNode.category) {
                case "PROCESS" :
                    processObj.targetProcessNode = targetProcessNode;
                    break;
                case "MATERIAL" :
                    materialObj.targetProcessNode = targetProcessNode;
                    break;
                case "ANALYSIS" :
                    analysisObj.targetProcessNode = targetProcessNode;
                    break;
                case "MEASUREMENT" :
                    measurementObj.targetProcessNode = targetProcessNode;
                    break;
                case "EQUIPMENT" :
                    equipmentObj.targetProcessNode = targetProcessNode;
                    break;
            }
        }

        for (let item of Object.entries(correctionTargetProcessData.nodeInfo)) {
            // nodeInfo에서 첫번쨰 데이터를 사용
            let correctionTargetProcessNode = item[1][Object.keys(item[1])[0]][0];
            switch (correctionTargetProcessNode.category) {
                case "PROCESS" :
                    processObj.correctionTargetProcessNode = correctionTargetProcessNode;
                    break;
                case "MATERIAL" :
                    materialObj.correctionTargetProcessNode = correctionTargetProcessNode;
                    break;
                case "ANALYSIS" :
                    analysisObj.correctionTargetProcessNode = correctionTargetProcessNode;
                    break;
                case "MEASUREMENT" :
                    measurementObj.correctionTargetProcessNode = correctionTargetProcessNode;
                    break;
                case "EQUIPMENT" :
                    equipmentObj.correctionTargetProcessNode = correctionTargetProcessNode;
                    break;
            }
        }

        function setData(obj: Object, category: String) {
            if (obj["targetProcessNode"] != null && obj["correctionTargetProcessNode"] != null) {
                obj["registFlag"] = true;
                obj["registTypeError"] = false;
                obj["targetDataType"] = targetProcess.processType;
                obj["targetDataId"] = targetProcessId;
                obj["correctionTargetType"] = correctionTargetProcess.processType;
                obj["correctionTargetId"] = correctionTargetProcessId;
            } else if ( // 둘 중 한개만 null인경우 >> 목적이 서로 상이한 경우에는 표시
                (obj["targetProcessNode"] != null && obj["correctionTargetProcessNode"] == null)
                || (obj["targetProcessNode"] == null && obj["correctionTargetProcessNode"] != null)) {
                obj["registFlag"] = false;
                obj["registTypeError"] = true;
                obj["targetDataType"] = targetProcess.processType;
                obj["targetDataId"] = targetProcessId;
                obj["correctionTargetType"] = correctionTargetProcess.processType;
                obj["correctionTargetId"] = correctionTargetProcessId;
            }
            commit("setState", [category, {...obj}]);
        }

        setData(processObj, "registProcess");
        setData(materialObj, "registMaterial");
        setData(analysisObj, "registAnalysis");
        setData(measurementObj, "registMeasurement");
        setData(equipmentObj, "registEquipment");
    },
    resetRegistDictionaryData({state, commit}, {category}) {
        const initObj = {
            registFlag: false,
            registTypeError: false,
            targetProcessNode: null, // 상대
            correctionTargetProcessNode: null, // 수정 대상
            targetDataType: null,   // 상대의 data type
            targetDataId: null,     // 상대의 data id
            correctionTargetType: null, // 수정 대상의 data type
            correctionTargetId: null,   // 수정 대상의 data id
        }
        switch (category) {
            case "PROCESS" :
                commit("setState", ["registProcess", {...initObj}]);
                break;
            case "MATERIAL" :
                commit("setState", ["registMaterial", {...initObj}]);
                break;
            case "ANALYSIS" :
                commit("setState", ["registAnalysis", {...initObj}]);
                break;
            case "MEASUREMENT" :
                commit("setState", ["registMeasurement", {...initObj}]);
                break;
            case "EQUIPMENT" :
                commit("setState", ["registEquipment", {...initObj}]);
                break;
            case "ALL" :
                commit("setState", ["registProcess", {...initObj}]);
                commit("setState", ["registMaterial", {...initObj}]);
                commit("setState", ["registAnalysis", {...initObj}]);
                commit("setState", ["registMeasurement", {...initObj}]);
                commit("setState", ["registEquipment", {...initObj}]);
                break;
        }
    },
    findRegistDataByCategory({state}, {category}) {
        //MATERIAL ANALYSIS MEASUREMENT EQUIPMENT
        switch (category) {
            case "PROCESS" :
                return state.registProcess;
            case "MATERIAL" :
                return state.registMaterial;
            case "ANALYSIS" :
                return state.registAnalysis;
            case "MEASUREMENT" :
                return state.registMeasurement;
            case "EQUIPMENT" :
                return state.registEquipment;
        }
    },
    callResetLinkNodeFunc({state, commit, dispatch}) {
        if (state.resetLinkNodeFunc) {
            state.resetLinkNodeFunc();
        }
    },
    resetTagAddBtnNew({state, commit, dispatch}) {
        state.tagAddBtnNewData = {};
        state.tagAddBtnNewFunc = null;
        state.tagAddBtnNewOpenFlag = false;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};